import { Icon } from "../Icon.jsx";

const FLEET_TABS = [
  {
    id: "SCHEDULED",
    icon: "truck",
    label: "Terjadwal",
    description: "Pantau FO aktif dan kesiapan berangkat",
  },
  {
    id: "COMPLETED",
    icon: "check",
    label: "Selesai",
    description: "Tinjau perjalanan yang telah diselesaikan",
  },
  {
    id: "CANCELLED",
    icon: "close",
    label: "Dibatalkan",
    description: "Tinjau FO yang dibatalkan",
  },
];

export function FleetOrdersCommandHeader({
  contextLabel,
  loading,
  onRefresh,
  subtitle,
  totalCount,
  updatedAt,
}) {
  return (
    <header className="fleet-command-header">
      <div className="fleet-command-header__identity">
        <span className="fleet-command-header__eyebrow">Kontrol Perjalanan</span>
        <div className="fleet-command-header__title-row">
          <h1>Fleet Order</h1>
          <span className="fleet-command-header__context">{contextLabel}</span>
        </div>
        <p>{subtitle}</p>
      </div>

      <div className="fleet-command-header__system" aria-label="Status data Fleet Order">
        <span className="fleet-command-header__system-icon" aria-hidden="true">
          <Icon name="database" size={18} />
        </span>
        <div>
          <span>Sumber Data</span>
          <strong>Database Route Planning</strong>
          <small>{updatedAt ? `Diperbarui ${updatedAt}` : "Menunggu pembaruan"}</small>
        </div>
        <div className="fleet-command-header__count">
          <span>Hasil Aktif</span>
          <strong>{totalCount}</strong>
          <small>Fleet Order</small>
        </div>
      </div>

      <div className="fleet-command-header__actions">
        <button
          className="primary-button fleet-command-header__primary-action"
          disabled={loading}
          onClick={onRefresh}
          type="button"
        >
          <Icon name="refresh" size={16} />
          {loading ? "Memuat…" : "Segarkan Data"}
        </button>
      </div>
    </header>
  );
}

export function FleetOrdersWorkspaceTabs({ activeTab, counts, onChange }) {
  return (
    <div className="fleet-workspace-tabs" aria-label="Konteks Fleet Order" role="tablist">
      {FLEET_TABS.map((tab) => {
        const active = activeTab === tab.id;

        return (
          <button
            aria-selected={active}
            className={active ? "is-active" : ""}
            key={tab.id}
            onClick={() => onChange(tab.id)}
            role="tab"
            tabIndex={active ? 0 : -1}
            type="button"
          >
            <span className="fleet-workspace-tabs__icon" aria-hidden="true">
              <Icon name={tab.icon} size={17} />
            </span>
            <span className="fleet-workspace-tabs__copy">
              <span>
                <strong>{tab.label}</strong>
                <em>{counts?.[tab.id] ?? 0}</em>
              </span>
              <small>{tab.description}</small>
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function FleetOrdersKpiStrip({ children, label }) {
  return (
    <section aria-label={label} className="fleet-kpi-section">
      <header className="fleet-kpi-section__header">
        <span>
          <Icon name="database" size={13} />
          {label}
        </span>
        <small>Seluruh hasil filter aktif</small>
      </header>
      <div className="fleet-overview-grid">{children}</div>
    </section>
  );
}

export function FleetOrdersFilterWorkbench({ activeFilters, children }) {
  return (
    <section className="fleet-filter-workbench" aria-label="Filter Fleet Order">
      <header className="fleet-filter-workbench__heading">
        <div>
          <span className="fleet-filter-workbench__icon" aria-hidden="true">
            <Icon name="filter" size={15} />
          </span>
          <div>
            <strong>Filter Fleet Order</strong>
            <span>Cari perjalanan, lalu batasi tanggal, rute, kesiapan, atau visibilitas.</span>
          </div>
        </div>
        <small>Perubahan diterapkan setelah menekan Terapkan.</small>
      </header>
      {children}
      {activeFilters}
    </section>
  );
}

export function FleetActiveFilterSummary({ labels, onClear, showClear = true }) {
  return (
    <div className="fleet-active-filters" aria-live="polite">
      <span className="fleet-active-filters__label">Filter aktif</span>
      <div className="fleet-active-filters__chips">
        {labels.length ? (
          labels.map((label) => <span key={label}>{label}</span>)
        ) : (
          <span className="is-neutral">Visibilitas: Aktif</span>
        )}
      </div>
      {showClear && labels.length > 0 && (
        <button className="text-button" onClick={onClear} type="button">
          Bersihkan
        </button>
      )}
    </div>
  );
}

export function FleetOrdersListHeader({ context, description, title }) {
  return (
    <header className="fleet-data-surface__header">
      <div>
        <span className="fleet-data-surface__eyebrow">Daftar Operasional</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      {context}
    </header>
  );
}
